import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { BooleanInput, FormWithRedirect, ReferenceInput, SelectInput, TextInput, Toolbar } from "react-admin";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import CreatedByInput from "../../../../Components/ReferenceFields/CreatedBy/CreatedByInput";
import { SourceCustomer } from "../../Customer";
import { SourceRemoveReasonTypes } from "../../RemovalReasonType";

const RemoveReasonDetailEditForm = props => {
  return (
    <FormWithRedirect
      {...props}
      render={(formProps: any) => (
        <Card>
          <form>
            <CardContent>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={2}>
                  <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Creation Information
                    </Typography>
                    <BooleanInput label="Active/Passive" source="isActive" />
                    <BooleanInput label="IsRequired" source="isRequired" />
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CreatedByInput disabled fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="createdDate" label="CREATED DATE" fullWidth showTime disabled />
                    </Box>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <ReferenceInput
                        label="CUSTOMER"
                        source="id"
                        reference={SourceCustomer}
                        required
                        perPage={99999}
                        filters={{ isActive__eq: true }}
                        disabled
                        fullWidth
                      >
                        <SelectInput optionText="customerName" optionValue="id" />
                      </ReferenceInput>
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <ReferenceInput
                        label="REMOVE REASON TYPE"
                        source="id"
                        reference={SourceRemoveReasonTypes}
                        perPage={99999}
                        filters={{ isActive__eq: true }}
                        fullWidth
                        disabled
                      >
                        <SelectInput optionText="removeReasonTypeName" optionValue="id" />
                      </ReferenceInput>
                    </Box>
                  </Box>
                  <Box mt="1em">
                    <Typography variant="h6" gutterBottom color="primary">
                      Updatable Field
                    </Typography>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput source="removeReasonDetailCode" label="REMOVE REASON DETAIL CODE" required fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput source="removeReasonDetailName" label="REMOVE REASON DETAIL NAME" required fullWidth />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={true}
              invalid={formProps.invalid}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
            />
          </form>
        </Card>
      )}
    />
  );
};

export default RemoveReasonDetailEditForm;
